import React, { useState, useEffect } from "react";
import NewResubmitRequest from "./NewResubmitRequest";
import ResubmitDetails from "./ResubmitDetails";
import NmefSpinner from "../../NmefSpinner";

import { Box } from "@mui/material";

import { ApplicationDataAPI } from "../../API/ApplicationDataAPI";

export default function ResubmitUI({
	anchorEl,
	setResubmitEl,
	resubmitEl,
	app
}) {
	const [isLoading, setIsLoading] = useState(true);
	const [userSubmittedRequest, setUserSubmittedRequest] = useState(false);

	const [resubmitDetailsResponse, setResubmitDetailsResponse] = useState([]);

	useEffect(() => {
		initializeData();
	}, []);

	const initializeData = async () => {
		try {
			let ResubmitDetailsResponse = await ApplicationDataAPI.fetchResubmit(
				app.id,
				app.locked_by_email
			);

			if (ResubmitDetailsResponse && ResubmitDetailsResponse.length >= 1) {
				
				// sort by date here... resubmit_decision_date
				ResubmitDetailsResponse.sort((a, b) => {
					const dateA = new Date(a.resubmit_decision_date);
					const dateB = new Date(b.resubmit_decision_date);
					return dateB - dateA;
				});

				setResubmitDetailsResponse(ResubmitDetailsResponse);
				setUserSubmittedRequest(true);
			}

			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
		}
	};

	return (
		<div>
			{isLoading ? (
				<Box
					zIndex={999}
					style={{
						borderRadius: "10px",
						backgroundColor: "rgb(246, 246, 246)",
						position: "absolute",
						padding: "50px",
						color: "black",
						right: "180px",
					}}>
					<NmefSpinner style={{ color: "black" }} />
				</Box>
			) : userSubmittedRequest ? (
				<ResubmitDetails
					anchorEl={resubmitEl}
					setResubmitEl={setResubmitEl}
					setUserSubmittedRequest={setUserSubmittedRequest}
					app={app}
					resubmitDetailsResponse={resubmitDetailsResponse}
				/>
			) : (
				<NewResubmitRequest
					anchorEl={resubmitEl}
					setResubmitEl={setResubmitEl}
					app={app}
				/>
			)}
		</div>
	);
}
